import { render } from "./MessageCom.vue?vue&type=template&id=1081c153&ts=true"
import script from "./MessageCom.vue?vue&type=script&lang=ts"
export * from "./MessageCom.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QSelect,QIcon,QChip,QItem,QItemSection,QInput,QCardSection,QInnerLoading,QBtn});qInstall(script, 'directives', {Ripple,ClosePopup});
